import { fillPlot, linePlot, periodInput } from "../definitionHelpers";
import { PALETTE } from "../palette";
import { isDownFractal, isUpFractal } from "../math/fractals";

const previousValue = (values, index) => (index > 0 && Number.isFinite(values[index - 1]) ? values[index - 1] : NaN);

/**
 * Fractal Chaos Bands (research §1.4). Not in TradingView, the classic
 * formula: the upper band holds the high of the last up fractal, the lower
 * one the low of the last down fractal (fractals as in Fractal), from the
 * bar that completes the fractal on.
 */
export default {
  id: "fractal-chaos-bands",
  name: "Fractal Chaos Bands",
  isOscillator: false,
  inputs: [
    periodInput("period", "Period", 2, { min: 2, max: 100 }),
  ],
  plots: [
    linePlot("up", "Up", PALETTE.LIME),
    linePlot("down", "Down", PALETTE.AQUA),
    fillPlot("background", "Background", PALETTE.LIME, ["up", "down"]),
  ],
  levels: [],

  calculate: (bars, { period }, series, fromIndex) => {
    for (let index = fromIndex; index < bars.length; index += 1) {
      const centre = index - period;

      series.up[index] =
        centre >= 0 && isUpFractal(bars, centre, period) ? bars[centre].high : previousValue(series.up, index);
      series.down[index] =
        centre >= 0 && isDownFractal(bars, centre, period) ? bars[centre].low : previousValue(series.down, index);
    }
  },
};
